import { Controller } from "react-hook-form";

import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
// import Button from "@mui/material/Button";

export const ReturnInfo = ({ returnData, control }) => {
  const validationHelper = {
    returnRef: { required: "Reference is required" },
    packType: { required: "Package Type is required" },
    packNo: {
      required: "Package quantity is required",
      min: "Must be at least 1",
    },
  };

  return (
    <Stack direction="row" spacing={1}>
      <Controller
        name="returnOrder.returnRef"
        // defaultValue={""}
        control={control}
        rules={{
          required: true,
        }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            fullWidth
            size="small"
            label="Reference"
            error={error !== undefined}
            helperText={error ? validationHelper.returnRef[error.type] : ""}
          />
        )}
      />
      <Controller
        name="returnOrder.packType"
        // defaultValue={returnData.data.data.returnOrder.packType || ""}
        control={control}
        rules={{
          required: true,
        }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            select
            size="small"
            fullWidth
            label="Package Type"
            error={error !== undefined}
            helperText={error ? validationHelper.packType[error.type] : ""}
          >
            <MenuItem value="Box">Box</MenuItem>
            <MenuItem value="Bag">Bag</MenuItem>
          </TextField>
        )}
      />
      <Controller
        name="returnOrder.packNo"
        // defaultValue={1}
        control={control}
        rules={{
          required: true,
          min: 1,
        }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            fullWidth
            type="number"
            size="small"
            label="Package Quantity"
            error={error !== undefined}
            helperText={error ? validationHelper.packNo[error.type] : ""}
            slotProps={{
              htmlInput: { min: 0, step: 1 },
            }}
          />
        )}
      />
    </Stack>
  );
};
